import { render, staticRenderFns } from "./CollapseComponent.vue?vue&type=template&id=2900427c&"
import script from "./CollapseComponent.vue?vue&type=script&lang=js&"
export * from "./CollapseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports